import React, { useState, useRef, useEffect } from 'react';
import { Button, Input } from 'antd';
import { useDebounce } from 'hooks/useDebounce';
import SearchIcon from 'assets/icons/Search.svg?react';

interface SearchInputProps {
  placeholder?: string;
  onSearch: (keyword: string) => void;
  debounceMs?: number;
  width?: number | string;
  initialValue?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder = 'Rechercher',
  onSearch,
  debounceMs = 500,
  width = 400,
  initialValue = '',
}) => {
  const [value, setValue] = useState(initialValue);
  const debounced = useDebounce(value, debounceMs);
  const isFirstRender = useRef(true);
  // `onSearch` gardé dans une ref : un parent qui recrée cette callback à chaque
  // rendu (ex: dépendante de l'URL) ne doit pas redéclencher une recherche —
  // seul un changement de la valeur débouncée doit le faire.
  const onSearchRef = useRef(onSearch);
  useEffect(() => {
    onSearchRef.current = onSearch;
  }, [onSearch]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    onSearchRef.current(debounced.trim());
  }, [debounced]);

  return (
    <div className="flex" style={{ width, maxWidth: '100%' }}>
      <Input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        allowClear
        className="h-10 rounded-l-md rounded-r-none"
        style={{ fontSize: 16 }}
      />
      <Button className="h-10 flex items-center justify-center border-l-0 rounded-l-none rounded-r-md bg-white">
        <SearchIcon className="w-4 h-4 text-gray-500" />
      </Button>
    </div>
  );
};

export default SearchInput;
